// Michigan Market Data - Real market rates and multipliers
// Source: Internal market research spreadsheet

export const MICHIGAN_MARKETS = {
  'ANN_ARBOR': {
    city: 'Ann Arbor',
    county: 'Washtenaw',
    multiplier: 1.03,
    marketAnalysis: 'Ann Arbor Metro - University Town, High Demand'
  },
  'DETROIT': {
    city: 'Detroit', 
    county: 'Wayne',
    multiplier: 1.02,
    marketAnalysis: 'Detroit Metro - Urban Core, Growing Market'
  },
  'GRAND_RAPIDS': {
    city: 'Grand Rapids',
    county: 'Kent', 
    multiplier: 0.84,
    marketAnalysis: 'Grand Rapids Metro - Mid-Size City, Stable Market'
  },
  'LANSING': {
    city: 'Lansing',
    county: 'Ingham',
    multiplier: 0.96,
    marketAnalysis: 'Lansing Metro - State Capital, Government/University'
  },
  'EAST_LANSING': {
    city: 'East Lansing',
    county: 'Ingham', 
    multiplier: 0.96,
    marketAnalysis: 'East Lansing - University Town, Student Housing'
  },
  'KALAMAZOO': {
    city: 'Kalamazoo',
    county: 'Kalamazoo',
    multiplier: 0.94,
    marketAnalysis: 'Kalamazoo Metro - University/Healthcare Hub'
  },
  'FLINT': {
    city: 'Flint',
    county: 'Genesee',
    multiplier: 0.98,
    marketAnalysis: 'Flint Metro - Recovery Market, Affordable Housing Focus'
  },
  'BATTLE_CREEK': {
    city: 'Battle Creek',
    county: 'Calhoun',
    multiplier: 0.94,
    marketAnalysis: 'Battle Creek - Mid-Size City, Corporate Presence'
  },
  'BAY_CITY': {
    city: 'Bay City',
    county: 'Bay',
    multiplier: 0.93,
    marketAnalysis: 'Bay City - Small City, Waterfront Community'
  },
  'BENTON_HARBOR': {
    city: 'Benton Harbor',
    county: 'Berrien',
    multiplier: 0.95,
    marketAnalysis: 'Benton Harbor - Lake Michigan, Tourism Potential'
  },
  'CHEBOYGAN': {
    city: 'Cheboygan',
    county: 'Cheboygan',
    multiplier: 0.94,
    marketAnalysis: 'Cheboygan - Northern Michigan, Seasonal Tourism'
  },
  'HOLLAND': {
    city: 'Holland',
    county: 'Ottawa',
    multiplier: 0.88,
    marketAnalysis: 'Holland - Lake Michigan, Tourism/Manufacturing'
  },
  'JACKSON': {
    city: 'Jackson',
    county: 'Jackson',
    multiplier: 0.97,
    marketAnalysis: 'Jackson - Mid-Size City, Central Location'
  },
  'MARQUETTE': {
    city: 'Marquette',
    county: 'Marquette',
    multiplier: 0.94,
    marketAnalysis: 'Marquette - Upper Peninsula, University Town'
  },
  'MIDLAND': {
    city: 'Midland',
    county: 'Midland',
    multiplier: 0.92,
    marketAnalysis: 'Midland - Chemical Industry Hub, Corporate Housing'
  },
  'MUSKEGON': {
    city: 'Muskegon',
    county: 'Muskegon',
    multiplier: 0.87,
    marketAnalysis: 'Muskegon - Lake Michigan, Recovery Market'
  },
  'SAGINAW': {
    city: 'Saginaw',
    county: 'Saginaw',
    multiplier: 0.92,
    marketAnalysis: 'Saginaw - Manufacturing Hub, Affordable Market'
  },
  'OTHER': {
    city: 'Other Michigan',
    county: 'Various',
    multiplier: 0.94,
    marketAnalysis: 'Other Michigan Markets - Average Statewide'
  }
};

// Base rates for different business models (monthly rates)
// These will be multiplied by the regional multipliers above
export const BASE_BUSINESS_MODEL_RATES = {
  marketRate: {
    studio: 950,
    oneBR: 1200,
    twoBR: 1450,
    studioPlus: 1050,
    oneBRPlus: 1350
  },
  shortTermRental: {
    studio: 2800,      // ~$93/night * 30 days
    oneBR: 3600,       // ~$120/night * 30 days  
    twoBR: 4500,       // ~$150/night * 30 days
    studioPlus: 3150,  // ~$105/night * 30 days
    oneBRPlus: 4050    // ~$135/night * 30 days
  },
  workforceHousing: {
    studio: 750,
    oneBR: 950,
    twoBR: 1150,
    studioPlus: 850,
    oneBRPlus: 1050
  }
};

// Utility function to get market-adjusted rates
export const getMarketAdjustedRates = (marketKey, businessModel) => {
  const market = MICHIGAN_MARKETS[marketKey];
  const baseRates = BASE_BUSINESS_MODEL_RATES[businessModel];
  
  if (!market || !baseRates) return null;
  
  const adjustedRates = {};
  Object.keys(baseRates).forEach(unitType => {
    adjustedRates[unitType] = Math.round(baseRates[unitType] * market.multiplier);
  });
  
  return {
    rates: adjustedRates,
    market: market,
    businessModel: businessModel
  };
};

// Get all available markets for dropdown selection
export const getAvailableMarkets = () => {
  return Object.keys(MICHIGAN_MARKETS).map(key => ({
    key,
    label: `${MICHIGAN_MARKETS[key].city}, ${MICHIGAN_MARKETS[key].county} County`,
    ...MICHIGAN_MARKETS[key]
  }));
}; 